import React from "react";
import {
  Image,
  ImageBackground,
  Modal,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

import { getRecursText, getRecursURL } from "../../Functions/getRecurs";
import globalstyle from "../../Styles/Globals/globals";
import style from "./style";

function PopUpInicial(RouterData, modalVisible, setModalVisible) {
  const { recursos, idioma, itinerari } = RouterData.route.params;

  // Parse HTML tags (br and b) in text
  const parseHtmlText = (htmlString) => {
    if (!htmlString || typeof htmlString !== "string") return null;

    // Check if string contains HTML tags
    if (!/<[^>]+>/i.test(htmlString)) {
      return htmlString;
    }

    // First replace all <br> tags with newlines
    let processed = htmlString.replace(/<br\s*\/?>/gi, "\n");
    
    // Then split by <b> tags and process
    const parts = processed.split(/(<b>.*?<\/b>)/i);
    const result = [];

    parts.forEach((part, index) => {
      if (!part) return;

      const boldMatch = part.match(/<b>(.*?)<\/b>/i);
      if (boldMatch) {
        // Bold text - keep newlines as part of the text
        result.push(
          <Text key={`bold-${index}`} style={{ fontWeight: "bold" }}>
            {boldMatch[1]}
          </Text>
        );
      } else {
        // Regular text - may contain newlines
        result.push(part);
      }
    });

    return result.length > 0 ? result : htmlString;
  };

  return (
    <Modal animationType="fade" transparent={true} visible={modalVisible}>
      <View style={style.modalOutBackground}>
        <View style={[style.caixaPopUp, { height: "100%", width: "100%" }]}>
          <ImageBackground
            source={{
              uri: getRecursURL(recursos, "05_background_tipus2", idioma),
            }}
            style={style.backgroundImatges}
          >
            {/* Close button */}
            <TouchableOpacity
              style={globalstyle.crossBox}
              onPress={() => setModalVisible(false)}
            >
              <Image
                source={{
                  uri: getRecursURL(recursos, "pop_up_close_icon", idioma),
                }}
                style={style.cross}
              />
            </TouchableOpacity>

            {/* Content Container - Centrally aligned */}
            <View style={{ 
              flex: 1, 
              alignItems: "center", 
              justifyContent: "center",
              width: "85%",
              paddingVertical: 20
            }}>
              {/* Top Question */}
              <Text style={style.popUpTitleInicial}>
                {getRecursText(recursos, "popup_inici_itinerari", idioma)}
              </Text>

              {/* Image */}
              <Image
                style={style.imageFlag}
                source={{
                  uri: getRecursURL(recursos, "popup_inici_itinerari_image", idioma),
                }}
              />

              {/* Text below image */}
              <Text style={style.popUpMapaText}>
                {(() => {
                  const textContent = getRecursText(recursos, "popup_inici_itinerari_2", idioma);
                  const parsed = parseHtmlText(textContent);
                  return parsed;
                })()}
              </Text>

              {/* Button */}
              <TouchableOpacity
                onPress={() => {
                  setModalVisible(false);
                }}
                style={[style.botoComencar, { marginTop: 20 }]}
              >
                <Text style={style.botoComencarText}>
                  {getRecursText(recursos, "text_iniciar", idioma)}
                </Text>
              </TouchableOpacity>
            </View>
          </ImageBackground>
        </View>
      </View>
    </Modal>
  );
}

export default PopUpInicial;
